<h2>POSIZIONI ACCADEMICHE</h2>
<p>
	In questa pagina si segnalano le posizioni accademiche bandite nel settore
	della Crittografia.
</p>
<p>
	Per segnalare nuove posizioni, i Soci possono scrivere all'indirizzo
	<a href="mailto:academics@decifris.it">academics&#64;decifris.it</a>.
</p>
<hr>
<h3> BANDI APERTI</h3>
<p>
	<strong> Postdoctoral Fellow (RTDA) </strong> - Università di Trento
</p>
<p>
	We are pleased to announce a 3 year Senior Postdoctoral Fellow Position (RTDA-INFO-01/A) at the University of
	Trento.
</p>
<ul>
	<li>
		Project Title: Quantum-safe Solutions for Digital Identity and digital Tracing
	</li>
	<li>
		Duration: three years
	</li>
	<li>
		Application Deadline: January 16th, 2025
	</li>
	<li>
		Research Areas: Post-quantum cryptography; Protocols and technologies for digital identity; Methodologies for
		the efficient and secure execution of smart contracts
	</li>
	<li>
		Application and more info: <a
			href="https://lavoraconnoi.unitn.it/en/bando-dr-valcomp/1551-2024-dmath">https://lavoraconnoi.unitn.it/en/bando-dr-valcomp/1551-2024-dmath</a>
	</li>
	<li>
		Contact person: Prof. Roberto Zunino, roberto.zunino&#64;unitn.it
	</li>
</ul>


<!--p>
						Al momento non ci sono bandi disponibili.
					</p-->
<hr><!---------------------------------------------------->

<h3> BANDI SCADUTI</h3>
<p>
	<strong> Post-doc </strong> - Università di Genova
</p>
<p>
	There is an open call for a postdoctoral position at the Department of Mathematics at the University of Genova
	(Italy) in Algebra/Geometry and their applications to Cryptography. The position is funded by the PRIN 2022 Grant
	"Mathematical Primitives for Post-Quantum Digital Signatures." It is a
	one-year position, with no teaching obligations and some research funds. The expected start date is February 2,
	2025, with limited flexibility. The annual gross salary is approximately €23,250.
	<br>
	The selected candidate will work under my supervision and will be encouraged to develop their own research program.
	Strong familiarity with one or more of the following areas is expected: Commutative Algebra, Algebraic Geometry,
	Computational Algebra systems (particularly Macaulay2 and Magma), and Cryptography.
	<br><br>
	The deadline for applications is November 8, 2024, at 12:00 PM (Italian time). The official call and online
	application procedure can be accessed <a href="https://concorsi.unige.it/home/procedure/4970/?__language=en">at the
		following link</a>. Please ensure that your application includes a brief research statement (maximum 1 page),
	all publications
	(including preprints and your PhD thesis), and any relevant documents or information. Be sure to complete Forms B
	and C, as indicated in the application. While letters of recommendation are not mandatory, they are highly
	appreciated and may be sent directly to me at: <a
		href="mailto:alessio.caminata@unige.it">alessio.caminata&#64;unige.it</a>. Feel free to contact me for further
	information.
	<br><br>
	Please note that interviews (conducted via Skype) are scheduled for December 13, 2024, beginning at 14:00.
	Shortlisted applicants will be notified a few days in advance.
</p>
<hr>
<p>
	<strong> Research Fellow </strong> - Università degli Studi Roma Tre
</p>
<p>
	We are pleased to announce a research fellow position opportunity at Roma Tre University under the project:
</p>
<p>
	Project Title: "Exploring Multiparty Computation and Number Theory: Algorithmic and Algebraic Perspectives"
</p>
<p>
	Funding Source: Laboratory of Cryptography and Cybersecurity <br>
	Duration: One year (with the possibility of extension for an additional year) <br>
	Application Deadline: January 20, 2024 <br>
	Research Areas: Cryptography, Algebra, Computer Science, Mathematical Logic. <br>
	Bando di concorso Rep. 27_Prot. 1756/2023 (<a href="https://shorturl.at/dzFSX">https://shorturl.at/dzFSX</a>) <br>
	[Application Forms] (<a href="https://shorturl.at/mtyLZ">https://shorturl.at/mtyLZ</a>) <br>
	[Annexes] (<a href="https://shorturl.at/htEP9">https://shorturl.at/htEP9</a>)
</p>
<p>
	Contact person: <br>
	Prof. Marco Pedicini <br>
	Department of Mathematics and Physics <br>
	Roma Tre University <br>
	Via della Vasca Navale 84 I-00146 Roma (Italy) <br>
	Email: <a href="mailto:marco.pedicini@uniroma3.it"> marco.pedicini&#64;uniroma3.it</a> <br>
	Website: <a href="http://www.mat.uniroma3.it/users/pedicini">http://www.mat.uniroma3.it/users/pedicini</a>
</p>
<p>
	Roma Tre University encourages applications from candidates of all backgrounds. Don't miss this opportunity to
	contribute to cutting-edge research in the field of cryptography.
</p>

<hr><!---------------------------------------------------->

<p><strong> Borsa di dottorato in crittografia </strong></p>
<p>Sede: Università degli Studi Roma Tre</p>
<p>Scadenza: 27 giugno 2023 ore 14</p>
<p>Argomento: Valutazione delle proprietà di sicurezza di primitive crittografiche</p>
<p>Per informazioni contattare: <a href="mailto:marco.pedicini@uniroma3.it"> marco.pedicini&#64;uniroma3.it</a> -- <a
		href="mailto:dottorato.matematica@uniroma3.it">dottorato.matematica&#64;uniroma3.it</a> </p>

<hr><!---------------------------------------------------->

<p><strong> Applied cryptographer </strong> - FBK (Trento) </p>
<p> Fondazione Bruno Kessler (Trento, ITALY) has a free position as applied cryptographer
	to join its team in the design and development of secure innovative solutions for
	digital identity, access control, and their integration with other security services.
</p>
<p>Topics of interest include:</p>
<ul>
	<li>
		development and performance assessments of cryptographic primitives and
		protocol implementations;
	</li>
	<li>
		innovative cryptography in digital identity and access control, e.g.,
		zero-knowledge proofs for privacy-enhancing protocols, attribute-based encryption;
	</li>
	<li>
		cryptographic solutions for secure development on distributed and heterogeneous
		architectures.
	</li>
</ul>
<p> Start date: June 2023</p>
<p>
	For more informations see the
	<a
		href="https://jobs.fbk.eu/Annunci/Jobs_Within_the_Piano_Nazionale_di_Ripresa_e_Resilienza_PNRR_initiative_FBK_is_looking_for_one_research_position_in_the_field_of_Applied_Cryptography_226786849.htm">
		link </a>
</p>
<hr><!---------------------------------------------------->
<p>
	<strong>Ricercatore RTDA in Crittografia</strong> - Università di Trento
</p>
<p>
	<strong>Scadenza</strong>: 13 febbraio 2023
</p>
<p>
	il Dipartimento di Matematica di Trento bandisce una posizione di ricercatore di tipo RTDA nei settori SSC 01/A02 -
	SSD MAT/02 Algebra.
</p>
<p>
	Dal bando ufficiale:
	<em> Il programma di ricerca si incardina nel Settore Scientifico Disciplinare MAT/02 -
		Algebra e, nello specifico, si focalizza sugli aspetti algebrici della crittografia,
		compresi gli algoritmi di crittografia post-quantum e le loro applicazioni alla gestione
		dell’identità digitale. Si prevede collaborazione nelle attività di consulenza e di terza
		missione del Dipartimento nell'ambito della crittografia, soprattutto all'interno del Laboratorio
		congiunto "Crittografia applicata e tecnologia blockchain" tra il Dipartimento di Matematica
		e il Centro per la Cybersecurity.</em>
</p>
<p> Per maggiori informazioni vedere il <a
		href="https://www.unitn.it/ateneo/bando-dr-valcomp/77769/valutazione-comparativa-a-n-1-posto-di-ricercatore-post-doc-art-24-co-3-lett-a-l-2402010-settore-c">
		bando</a></p>
<hr>
<!-- <p>
						Segnaliamo due posizioni postdoc che potrebbero essere di interesse:
					</p>
					<ul>
						<li>
							Una posizione per crittografia post-quantum al Basque Center 
							of Applied Mathematics, Spagna. Per maggiori dettagli clicca 
							<a href="http://www.bcamath.org/documentos_public/archivos/ofertas/
							IC2021_11_Postoc_IKUR_STAGv2.pdf">qui</a>.							
						</li>
						<li>
							Una posizione per crittografia basata su reticoli presso 
							l'Università di Aalto, Finlandia. Per maggiori dettagli
							clicca <a href="https://www.aalto.fi/en/open-positions/
							postdoctoral-researcher-in-mathematics-lattice-based-cryptography">
							qui</a>.
						</li>
					</ul>  -->